/* Finish dots on a product card. B, 2026-08-17.
 *
 * Click a dot -> the card's photo becomes that finish and the dot keeps the Plum ring.
 * Hover is CSS only (it previews the ring and does not touch the photo) -- B's call,
 * 2026-08-17: "roll can just select, but if you click the dot, the image changes."
 *
 * ONE DELEGATED LISTENER ON THE DOCUMENT, not one per card. A collection page renders
 * dozens of cards and the rails render more; binding per card would mean hundreds of
 * listeners and would miss anything injected later by paginate/filter, which replace the
 * grid's markup wholesale. Delegation survives that for free.
 *
 * THE GUARD IS LOAD-BEARING. The snippet emits this script tag per card, because Liquid
 * `render` is isolated and there is no "once per page" flag to hang it on. Duplicate
 * <script src> tags fetch once but EXECUTE once each, so without the guard a page with 24
 * cards would bind 24 identical document listeners and every click would swap 24 times.
 */
(function () {
  if (window.__fmCardSwatches) return;
  window.__fmCardSwatches = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('.fm-card__sw') : null;
    if (!button) return;

    /* The dots sit inside .card__content, which carries no whole-card link -- that overlay
       was deleted on 2026-07-17 and the photo now carries its own <a>. So nothing should
       swallow this click. Stopping it anyway is cheap insurance against a future wrapper. */
    event.preventDefault();
    event.stopPropagation();

    var card = button.closest('.card-wrapper') || button.closest('.card');
    if (!card) return;

    /* THE TWO-AXIS PATH WAS DELETED ON 2026-09-13, WITH THE CHIPS IT EXISTED FOR.
     *
     * A card can carry exactly one picker again -- the finish dots -- and a dot stands for
     * its own representative variant, which is right by construction. The combination
     * resolver (read both selected values off the DOM, match them against a per-card table
     * of every variant) only existed because two controls each held half an answer. See
     * snippets/fernmade-card-swatches.liquid for why the chips went. */
    var url = button.getAttribute('data-fm-img');
    var image = card.querySelector('.card__media img');

    if (image && url) {
      /* srcset WINS OVER src whenever it is present, so setting src alone changes nothing
         visible. The responsive set belongs to the product's default finish and there is no
         per-finish set to swap in, so it is dropped rather than rewritten -- the 720w file
         is wider than the largest slot a card is ever given. */
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = url;
    }

    /* THE PRICE FOLLOWS THE DOT TOO. B, 2026-08-25: the Segment card showed
       "From $2,699" while the marble dot was selected, and the marble is $3,849.
       The rendered price is the PRODUCT's -- the cheapest variant across every axis --
       so it never moved. On a two-material page that is a $1,150 lie.

       The snippet computes each dot's own price server-side (one value can still span
       sizes, so it may itself be a "From" range) and hands it over in data-fm-price.
       Nothing is computed here: money formatting is Liquid's job and a JS copy of it
       would drift from the store's currency settings the first time they changed. */
    var priceText = button.getAttribute('data-fm-price');
    var compareText = button.getAttribute('data-fm-compare') || '';

    /* B, 2026-10-12 (the Conrad, Misewell's sale): ON A SALE CARD THE VISIBLE PRICE IS
       .price-item--sale, and the first .price-item--regular is the HIDDEN regular one, so the
       old single querySelector updated a span nobody could see. Both now take the dot's
       price, the struck "was" takes the dot's compare-at (data-fm-compare, blank when that
       finish is not on sale), and the on-sale state follows the dot. Text comes from Liquid
       (fernmade-card-compare / fernmade-card-price); nothing is formatted here. */
    if (priceText) {
      var nowEls = card.querySelectorAll('.price__regular .price-item--regular, .price-item--sale');
      for (var n = 0; n < nowEls.length; n++) nowEls[n].innerHTML = priceText;
    }
    var priceBox = card.querySelector('.price');
    var wasEl = card.querySelector('.fm-price__was');
    if (priceBox) priceBox.classList.toggle('price--on-sale', compareText !== '');
    if (wasEl) wasEl.innerHTML = compareText;

    /* ONE AXIS, SO CLEARING EVERY CONTROL IN THE CARD IS CORRECT AGAIN. The `data-fm-axis`
       scoping that stood here existed for the chips: with two pickers, clearing them all
       stripped the ring off the selected dot when a chip was clicked. With the chips gone
       the dots are the only `.fm-card__sw` on a card, and exactly one of them is lit. */
    /* A SIBLING DOT IS A DIFFERENT PRODUCT (2026-10-12): Collective lamps whose colours are
       separate products. data-fm-url is that product's URL, and every product link on the
       card follows it, so clicking through lands on the colour that is showing. */
    var productUrl = button.getAttribute('data-fm-url');
    if (productUrl) {
      var links = card.querySelectorAll('a[href*="/products/"]');
      for (var l = 0; l < links.length; l++) links[l].setAttribute('href', productUrl);
    }

    var peers = card.querySelectorAll('.fm-card__sw');
    for (var i = 0; i < peers.length; i++) {
      peers[i].classList.remove('is-selected');
    }
    button.classList.add('is-selected');
  });

  /* THERE IS NO LOAD-TIME PRICE SYNC HERE ANY MORE, AND IT MUST NOT COME BACK.
   *
   * A `fmSyncInitialPrices()` used to run on DOMContentLoaded and rewrite every card whose
   * dot was pre-selected, because the server sent the PRODUCT's floor while the photo
   * showed a different finish: the Owing card rendered "From $839" over the $939 walnut,
   * the Ellie "From $549" over the $879 leather, and three of five cards visibly flipped
   * on load. It worked, and it was the wrong place for it.
   *
   * B, 2026-08-29: the collection grid shows the price of the variant it displays A grid that is only correct once a script has run is not correct -- not
   * for a crawler that does not execute JS, not for a cached snapshot, not for the first
   * paint a shopper actually sees. [[feedback-first-paint-is-the-untested-state]]
   *
   * `card-product.liquid` now resolves the shown finish and prices it SERVER-SIDE, via
   * `fernmade-card-finish.liquid` and `fernmade-card-price.liquid` -- the same two snippets
   * that feed the dots below, so the markup ships correct and this file has nothing to fix.
   * Re-adding a sync would not be harmless duplication; it would be a second copy of the
   * rule, free to drift, which is exactly what `always_from` did.
   * See project-card-price-server-render.
   *
   * THE CLICK HANDLER ABOVE STAYS. Reacting to a click is genuinely JavaScript's job;
   * rendering the initial state never was.
   */
})();
